import React, { Component } from 'react';

export default class WorkLoyaltyLevel extends Component {

    constructor(props) {
        super(props);

        this.state = {
            level: ''
        };

        this.load = this.load.bind(this);
    }

    componentDidMount() {
        if (this.props.projectId)
        this.load();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.projectId !== this.props.projectId)
            this.load();
    }

    load() {
        var scope = this;
        var token = localStorage.getItem("token");
        fetch('api/Project/GetLoyaltyLevel?id=' + this.props.projectId, {
            method: 'GET',
            body: null,
            headers: {
                'Authorization': 'Bearer ' + token
            }
        }).then(function (res) {
            if (res.status === 401) {
            }
            else {
                res.json().then((result) => {
                    scope.setState({ level: result.level, color: result.color });
                }).catch((err) => console.log(err));
            }
        });
    }
    
    render() {
        return (
            <div>
                {!!this.state.level && <div><b>Уровень: <span style={{"color": this.state.color, "font-size": "2rem"}}>{this.state.level}</span></b></div>}
            </div>
        );
    }
}
